<template>
    <div :id="getFullModalId" class="ui basic modal" :dir="checkDirRightToLeft" :style="checkStyleTextAlignRight">
        <div class="ui icon header">
            <div :id="getFullModalId + '-title'" tabindex="0" class="title"
                 @keydown.shift.tab.prevent="focusElement('close-button')" v-text="modal.title">
            </div>
        </div>
        <div :id="getFullModalId + 'legalTextContent'" class="content" v-html="modal.content"></div>
        <div class="actions">
            <button :id="getFullModalId + '-close-button'" tabindex="0" class="ui inverted cancel button"
                    @keyup.enter="onEnter" @keydown.tab.exact.prevent="focusElement('title')">
                <i class="angle left icon"></i>{{ $t('common.button.back') }}
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { mixin } from '../../js/ciam-mixin.js'
import { ARABIC_LANGUAGE } from '../../js/constants'

/* global contextPath */

export default {
  props: {
    id: String,
    isLegalNotice: {
      type: Boolean,
      default: false
    },
    country: String
  },
  mixins: [mixin],
  data: function () {
    return {
      modal: {
        title: 'N/A',
        content: 'N/A'
      },
      loaded: false
    }
  },
  methods: {
    show: function () {
      if (!this.loaded) {
        const url = contextPath + '/toas/legalText?documentId=' + this.id + '&country=' + this.country
        this.getLoader.startLoading()
        $.get(url).done(this.setup).fail(this.onError)
      } else {
        this.showModal()
      }
    },
    setup: function (response) {
      this.modal.title = response.title
      this.modal.content = response.legalText
      // because vue is updating the data asynchronously we have to wait a tick,
      // to avoid having weird representation of the modal
      Vue.nextTick(this.showModal)
    },
    showModal: function () {
      this.modifyHashLinks()
      this.getLoader.stopLoading()
      $(`#${this.getFullModalId}`)
        .modal({ onShow: this.scrollTopOfModal })
        .modal('refresh')
        .modal('show')
    },
    onError: function (r) {
      console.error(r)
      $('.ui.form').form('add errors', [this.$t('errors.registration.loadLegalTexts')])
      this.getLoader.stopLoading()
    },
    modifyHashLinks: function () {
      if (!this.loaded) {
        console.debug(`Setting up hash links in modal [modal=${this.getFullModalId}]`)
        $(`#${this.getFullModalId} > .content a[href*="#"]`).click(function (event) {
          const target = document.getElementById(event.target.hash.replace('#', ''))
          if (target !== undefined && target !== null) {
            target.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
          event.preventDefault()
        })
        this.loaded = true
      }
    },
    scrollTopOfModal: function () {
      console.debug('Scrolling to top of modal')
      $(`#${this.getFullModalId}`).get(0).scrollIntoView(true)
    },
    onEnter: function () {
      $(`#${this.getFullModalId}`).modal('hide')
    },
    focusElement: function (identifier) {
      $(`#${this.getFullModalId}-${identifier}`).focus()
    }
  },
  computed: {
    checkDirRightToLeft: function () {
      const language = this.$store.state.lang ? this.$store.state.lang : ''
      if (language === ARABIC_LANGUAGE && this.isRTLCountry(this.country)) {
        return 'rtl'
      }
      return null
    },
    checkStyleTextAlignRight: function () {
      const language = this.$store.state.lang ? this.$store.state.lang : ''
      if (language === ARABIC_LANGUAGE && this.isRTLCountry(this.country)) {
        return 'text-align: right'
      }
      return null
    },
    getLoader: function () {
      return this.$parent.$parent.$parent.$parent.$refs.super
    },
    getFullModalId: function () {
      return 'modal-legalText-' + this.id
    }
  },
  beforeDestroy: function () {
    const modal = document.getElementById(this.getFullModalId)
    if (modal !== undefined && modal != null) {
      modal.remove()
      console.debug('Modal removed')
    }
  }
}
</script>

<style>
    .title {
        padding: 0 40px;
    }
</style>
